 
// Need to review above eslint disable property
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Default messages
 *
 * @file defaultMessages.js
 * @author Srinivasan Bakthavatchalam
 * @since 1.0.0
 */

import { defineMessages } from 'react-intl';

import enJson from './en.json';

const {
  activities,
  apply,
  audio,
  book,
  bookTabEmpty,
  cancel,
  clearAll,
  documents,
  download,
  downloadError,
  downloadSuccess,
  downloading,
  downloadFaild,
  figures,
  filterByResourceType,
  image,
  images,
  internal_links,
  misc,
  noResults,
  noResources,
  of,
  page,
  pageTabEmpty,
  quizzes,
  resourceType,
  resourceTypes,
  remove,
  removing,
  retry,
  searchEmpty,
  searchForAResource,
  selected,
  sparklab,
  student,
  teacher,
  videos,
  web_links,
  zipped_files
} = enJson;

const messages = defineMessages({
  student: {
    id: 'student',
    description: student,
    defaultMessage: student
  },
  teacher: {
    id: 'teacher',
    description: teacher,
    defaultMessage: teacher
  },
  book: {
    id: 'book',
    description: book,
    defaultMessage: book
  },
  page: {
    id: 'page',
    description: page,
    defaultMessage: page
  },
  resourceType: {
    id: 'resourceType',
    description: resourceType,
    defaultMessage: resourceType
  },
  resourceTypes: {
    id: 'resourceTypes',
    description: resourceTypes,
    defaultMessage: resourceTypes
  },
  clearAll: {
    id: 'clearAll',
    description: clearAll,
    defaultMessage: clearAll
  },
  apply: {
    id: 'apply',
    description: apply,
    defaultMessage: apply
  },
  filterByResourceType: {
    id: 'filterByResourceType',
    description: filterByResourceType,
    defaultMessage: filterByResourceType
  },
  searchForAResource: {
    id: 'searchForAResource',
    description: searchForAResource,
    defaultMessage: searchForAResource
  },
  audio: {
    id: 'audio',
    description: audio,
    defaultMessage: audio
  },
  documents: {
    id: 'documents',
    description: documents,
    defaultMessage: documents
  },
  activities: {
    id: 'activities',
    description: activities,
    defaultMessage: activities
  },
  internal_links: {
    id: 'internal_links',
    description: internal_links,
    defaultMessage: internal_links
  },
  image: {
    id: 'image',
    description: image,
    defaultMessage: image
  },
  images: {
    id: 'images',
    description: images,
    defaultMessage: images
  },
  figures: {
    id: 'figures',
    description: figures,
    defaultMessage: figures
  },
  quizzes: {
    id: 'quizzes',
    description: quizzes,
    defaultMessage: quizzes
  },
  videos: {
    id: 'videos',
    description: videos,
    defaultMessage: videos
  },
  web_links: {
    id: 'web_links',
    description: web_links,
    defaultMessage: web_links
  },
  zipped_files: {
    id: 'zipped_files',
    description: zipped_files,
    defaultMessage: zipped_files
  },
  sparklab: {
    id: 'sparklab',
    description: sparklab,
    defaultMessage: sparklab
  },
  misc: {
    id: 'misc',
    description: misc,
    defaultMessage: misc
  },
  selected: {
    id: 'selected',
    description: selected,
    defaultMessage: selected
  },
  remove: {
    id: 'remove',
    description: remove,
    defaultMessage: remove
  },
  download: {
    id: 'download',
    description: download,
    defaultMessage: download
  },
  cancel: {
    id: 'cancel',
    description: cancel,
    defaultMessage: cancel
  },
  downloadError: {
    id: 'downloadError',
    description: downloadError,
    defaultMessage: downloadError
  },
  downloadSuccess: {
    id: 'downloadSuccess',
    description: downloadSuccess,
    defaultMessage: downloadSuccess
  },
  downloading: {
    id: 'downloading',
    description: downloading,
    defaultMessage: downloading
  },
  retry: {
    id: 'retry',
    description: retry,
    defaultMessage: retry
  },
  downloadFaild: {
    id: 'downloadFaild',
    description: downloadFaild,
    defaultMessage: downloadFaild
  },
  removing: {
    id: 'removing',
    description: removing,
    defaultMessage: removing
  },
  of: {
    id: 'of',
    description: of,
    defaultMessage: of
  },
  searchEmpty: {
    id: 'searchEmpty',
    description: searchEmpty,
    defaultMessage: searchEmpty
  },
  bookTabEmpty: {
    id: 'bookTabEmpty',
    description: bookTabEmpty,
    defaultMessage: bookTabEmpty
  },
  pageTabEmpty: {
    id: 'pageTabEmpty',
    description: pageTabEmpty,
    defaultMessage: pageTabEmpty
  },
  noResults: {
    id: 'noResults',
    description: noResults,
    defaultMessage: noResults
  },
  noResources: {
    id: 'noResources',
    description: noResources,
    defaultMessage: noResources
  }
});

export default messages;
